var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.2vw",
    height: "1.2vw",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.029 9.62491C7.73221 9.93866 7.73225 10.4296 8.02908 10.7433L11.3303 14.2323C11.7248 14.6492 12.3885 14.6492 12.783 14.2323L15.9709 10.8629C16.2678 10.5491 16.2678 10.0582 15.971 9.74444C15.65 9.40507 15.1098 9.40505 14.7888 9.7444L12.7831 11.8645C12.3886 12.2816 11.7247 12.2816 11.3302 11.8646L9.21125 9.62485C8.8902 9.28551 8.35001 9.28553 8.029 9.62491Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/Arrow_down.4ebab3e4979727b2a3d66f3ece4480a8.svg";
export { ForwardRef as ReactComponent };